module.exports = __webpack_public_path__ + "static/media/TourManagementIcon.b4e0f65e.png";